import { createAction } from 'redux-actions';

import * as actionTypes from '../actionTypes/miscellaneous';

export const doCreateNotification = createAction(actionTypes.NOTIFICATION_CREATE_REQUEST);
export const doDisplayLoadingBar = createAction(actionTypes.LOADING_BAR_DISPLAY_REQUEST);
export const doDisplayMessageModal = createAction(actionTypes.MESSAGE_MODAL_CREATE_REQUEST);
